/**
 * @license Givaudan
 * @author Ayoub MHAMDI
 */
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { DefaultCurrencyPipe } from '@banyan/commons/pipes/default-currency.pipe';
import { DocumentService } from '@banyan/modules/shared/api/document/document.service';
import { CartEmptyComponent } from '@banyan/modules/shared/components/cart-empty/cart-empty.component';
import {
  FeatureTogglingDirective,
} from '@banyan/modules/shared/directives/feature-toggling/feature-toggling.directive';
import { FileService } from '@banyan/modules/shared/services/file/file.service';
import { PhoneNumberService } from '@banyan/modules/shared/services/phone-number/phone-number.service';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';
import { ContainerComponent } from '@banyan/modules/standalone/container/container.component';
import { ContentHeaderComponent } from '@banyan/modules/standalone/content-header/content-header.component';
import { GradientComponent } from '@banyan/modules/standalone/gradient/gradient.component';
import { ModalComponent } from '@banyan/modules/standalone/modal/modal.component';
import { PlusMinusButtonComponent } from '@banyan/modules/standalone/plus-minus-button/plus-minus-button.component';
import { TranslateModule } from '@ngx-translate/core';

import { BasketTableV2Component } from '../standalone/basket-table-v2/basket-table-v2.component';
import { CartTableV2Component } from '../standalone/cart-table-v2/cart-table-v2.component';
import { AccountRemovedComponent } from './components/account-removed/account-removed.component';
import { BasketTableComponent } from './components/basket-table/basket-table.component';
import { CartTableComponent } from './components/cart-table/cart-table.component';
import { PopinMenuComponent } from './components/popin-menu/popin-menu.component';
import { ProductModalComponent } from './components/product-modal/product-modal.component';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { RequestsOrdersComponent } from './components/requests-orders/requests-orders.component';
import { CountryService } from './services/country/country.service';
import { FeatureTogglingService } from './services/feature-toggling/feature-toggling.service';
import { SharedRoutingModule } from './shared.routing.module';

@NgModule({
  imports: [
    CommonModule,
    SharedRoutingModule,
    TranslateModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    PlusMinusButtonComponent,
    ContainerComponent,
    MatTabsModule,
    ContentHeaderComponent,
    NgOptimizedImage,
    GradientComponent,
    MatDialogModule,
    ModalComponent,
    CartTableV2Component,
    BasketTableV2Component,
    DefaultCurrencyPipe
  ],
  declarations: [
    AccountRemovedComponent,
    PopinMenuComponent,
    ProductModalComponent,
    RequestsOrdersComponent,
    CartTableComponent,
    CartEmptyComponent,
    ProgressSpinnerComponent,
    BasketTableComponent,
    FeatureTogglingDirective,
  ],
  providers: [
    CountryService,
    DocumentService,
    FileService,
    PhoneNumberService,
    FeatureTogglingService,
  ],
  exports: [
    PopinMenuComponent,
    ProductModalComponent,
    RequestsOrdersComponent,
    CartTableComponent,
    CartEmptyComponent,
    ProgressSpinnerComponent,
    BasketTableComponent,
    FeatureTogglingDirective,
  ],
})
export class SharedModule {
}
